"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var material_1 = require("@mui/material");

function Input(props) {
  var propsDefault = __assign({}, props);

  return react_1["default"].createElement(material_1.TextField, __assign({}, propsDefault));
}

exports["default"] = Input; //Defino las props que son obligatorias

Input.propTypes = {
  onChange: prop_types_1["default"].func.isRequired,
  value: prop_types_1["default"].any.isRequired
};